import React, { useEffect, useState } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import cup from "../../../assets/images/cup 2.png";
import EnterImage from "../../../assets/images/unsplash_hUHzaiAHuUc.png";
import { serverInfo } from "../../../App";
import { useContext } from "react";

const PromotionalList = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [events, setEvents] = useState([]);

 
  useEffect(() => {
    axios.get("/api/audition-admin/promotional/video").then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data?.event);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <div className="liveMeetupBorder mb-5">
          <div className="d-flex px-4 ">
            <div className="faTrophy">
              {" "}
              <img src={cup} alt="" />
            </div>
            <h4 className="mx-3 text-white p-2">Auditions Promotional List</h4>
          </div>

          <div className="pb-3">
            <div className="slick-parent d-flex justify-content-center">
              {events?.map((event, index) => (
                <div key={index} className="p-3">
                  <div className="card bg-dark completedMeetupBlack BlueBorder">
                    <img
                      src={
                        event.image
                          ? imageCdnUrl+event.image
                          : EnterImage
                      }
                      className="img-fluid p-2 ImgBlue"
                      alt=""
                      style={{
                        height: "200px",
                        width: "300px",
                      }}
                    />
                    <div className="p-3">
                      <center>
                        <h5 className="text-white text-center">
                          {event.audition.title ?? ""}
                        </h5>
                        <Link
                          to={`/audition-admin/promotional/video-view/${event.id}`}
                        >
                          <button className="btn BlueBtn w-100">View</button>
                        </Link>
                      </center>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromotionalList;
